export default __webpack_public_path__ + "static/media/FamilyNumber19.036c2b3f.svg";